import { inject } from '@angular/core';
import { CoreRegistryConfig } from '@celerofinancas/ui-interceptors';
import { TokenHandlerService } from '@celerofinancas/ui-oauth';
import { TokenExchangeEvents } from '@shared/models/token-exchange-events';
import { STORAGE_KEYS } from './storage';

/**
 * Factory function to create core registry configuration for this application.
 *
 * It mirrors the structure serasa-cl-webcomponents uses, without its business
 * customisations (tracking, the DDA agreement).
 *
 * @returns the core registry configuration for this application
 */
export function createCoreRegistryConfig(): CoreRegistryConfig {
  const tokens = inject(TokenHandlerService);

  return {
    coreRegistryUrlsWhiteList: ['economic_group/by', 'company/by/', 'me/read'],
    authWhiteList: [
      'auth/access_token',
      'auth/signin',
      'auth/token_exchange',
      'auth/refresh_token',
      'auth/logout',
      'openid-configuration',
      'csrf-token',
    ],
    companyParams: ['company_pk', 'company_id'],
    onError: () => {
      tokens.eventsSubject$.next({
        event: TokenExchangeEvents.TOKEN_EXCHANGED_FAILED,
      });
    },
    onInitialized: () => {
      if (!sessionStorage.getItem(STORAGE_KEYS.CELERO_APP_STARTED)) {
        sessionStorage.setItem(STORAGE_KEYS.CELERO_APP_STARTED, 'true');
      }
    },
  };
}
